"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
const utils_1 = require("../utils");
exports.default = new class FunctionComponent extends component_1.default {
    defaultOptions = {};
    get() {
        return (0, utils_1.getStack)()[3]?.getFunctionName();
    }
    ;
};
